import { ref } from 'vue'

// Clipboard access throws in an insecure context, so the flag only flips on a real write.
export const useCopy = (holdMs = 2000) => {
  const copied = ref(false)

  const copy = async (text: string) => {
    try {
      await navigator.clipboard.writeText(text)
      copied.value = true
      setTimeout(() => {
        copied.value = false
      }, holdMs)
    } catch {
      copied.value = false
    }
  }

  return { copied, copy }
}
